import React, { useId } from 'react';

/**
 * Daypop mark: rounded tile + waypoint pin (you are here).
 * Gradients use design-token golds (#D4A155 family) for crisp SVG at any size.
 */
export function DaypopLogo({ size = 40, className = '' }) {
  const uid = useId();
  const gid = `${uid}-tile`;
  const pid = `${uid}-pin`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      className={`shrink-0 ${className}`}
      aria-hidden
    >
      <defs>
        <linearGradient id={gid} x1="6" y1="4" x2="34" y2="36" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#4A8B7C" />
          <stop offset="45%" stopColor="#2F5D52" />
          <stop offset="100%" stopColor="#1A3831" />
        </linearGradient>
        <linearGradient id={pid} x1="12" y1="10" x2="28" y2="28" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#F7F6F2" />
          <stop offset="100%" stopColor="#D8E5E1" />
        </linearGradient>
      </defs>
      <rect x="3" y="3" width="34" height="34" rx="9" fill={`url(#${gid})`} />
      <path
        d="M20 9.5c-4.95 0-9 4.05-9 9 0 4.35 9 13.5 9 13.5s9-9.15 9-13.5c0-4.95-4.05-9-9-9z"
        fill={`url(#${pid})`}
      />
      <circle cx="20" cy="18.5" r="3.25" fill={`url(#${gid})`} />
    </svg>
  );
}

// Keep old names as aliases for backwards compatibility during migration
export const WaypointLogo = DaypopLogo;

export function DaypopBrand({
  logoSize = 40,
  wordmarkClassName = 'font-display text-2xl font-bold text-text-primary',
}) {
  return (
    <div className="flex items-center gap-3">
      <DaypopLogo size={logoSize} className="shadow-sm" />
      <span className={wordmarkClassName}>Daypop</span>
    </div>
  );
}

export const WaypointBrand = DaypopBrand;
